module.exports = __webpack_public_path__ + "static/media/rtr.b2607e52.png";